import React from "react";
import { Link } from "react-router-dom";
import StaticPage from "../../components/StaticPage";

const TOPICS = [
    { slug: "diabetes", label: "Diabetes" }, { slug: "hypertension", label: "Hypertension" },
    { slug: "cholesterol", label: "Cholesterol" }, { slug: "thyroid", label: "Thyroid" },
    { slug: "asthma", label: "Asthma" }, { slug: "pcos", label: "PCOS" },
    { slug: "anxiety", label: "Anxiety" }, { slug: "depression", label: "Depression" },
    { slug: "skin-care", label: "Skin care" }, { slug: "sleep", label: "Sleep" },
    { slug: "elderly-care", label: "Elderly care" }, { slug: "pregnancy", label: "Pregnancy" },
];

const Library = () => (
    <StaticPage
        title="Health Library"
        crumb="Library"
        testId="page-library"
        intro="Browse curated reading lists, treatment summaries and patient guides organised by topic."
    >
        <div className="flex flex-wrap gap-2">
            {TOPICS.map((t) => (
                <Link key={t.slug} to={`/library/${t.slug}`} className="rounded-full border border-zinc-200 bg-white px-3.5 py-1.5 text-sm text-zinc-700 transition-colors hover:border-brand-300 hover:bg-brand-50 hover:text-brand-700 dark:border-white/10 dark:bg-white/5 dark:text-zinc-200">
                    {t.label}
                </Link>
            ))}
        </div>
    </StaticPage>
);

export default Library;
